import { ref } from 'vue';

export function useInternalChatPro() {
  return {
    pollsEnabled: ref(true),
    maxPrivateChannels: ref(null),
    isSuperAdmin: false,
    isAdmin: false,
  };
}
